module.exports = __webpack_public_path__ + "static/colors-brand-dont-d7a29702bbb7b22d3899d385b875b34c.png";